import { isStaff } from '../../../utils/permissions';
import { Divider, Form, message, Modal } from 'antd';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import * as THREE from 'three';
import ToolbarDesign from '../../../pages/DesignerPage/components/ToolbarDesign/ToolbarDesign';
import { DesignerPageContext } from '../../../pages/DesignerPage/DesignerPage';
import ExtendedSceneManager from '../../../three/scenes/ExtendedSceneManager';
import { GeometryUtils } from '../../../utils/geometry/GeometryUtils';
import BottomSheet from '../../common/BottomSheet/BottomSheet';
import ButtonIconOutlineLarge from '../../common/ButtonIconOutline/ButtonIconOutlineLarge';
import ButtonPrimaryLarge from '../../common/ButtonPrimary/ButtonPrimaryLarge';
import ButtonSecondaryLarge from '../../common/ButtonSecondary/ButtonSecondaryLarge';
import InputComponent from '../../common/InputComponent/InputComponent';
import LoadingOverlay from '../../common/LoadingOverlay/LoadingOverlay';
import { openMessageError } from '../../common/Message/openMessageError';
import { openMessageWarning } from '../../common/Message/openMessageWarning';
import { openModal } from '../../common/Modal/openModal';
import { Icon } from '../../icon/icon';
import './CabinetTrimView.scss';
import { useForm } from 'antd/es/form/Form';
import { InsideType } from '../../../constants/enum';
import { InsideLoader } from '../../../three/loaders/InsideLoader';
import ButtonSelect from '../../common/ButtonSelect/ButtonSelect';
import { cn } from '../../../utils/string/cn.utils';
import { addToCart } from '../../../store/actions/room.action';
import { openMessageSuccess } from '../../common/Message/openMessageSuccess';
import { capitalize, set } from 'lodash';
// import { openDrawerCart } from '../../../pages/CartPage/components/DrawerCart/DrawerCart';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { openNotification } from '../../common/Notification/openNotification';
import { fetchPricePermanents } from '../../../store/actions/module.action';
import ButtonIconOutlineMedium from '../../common/ButtonIconOutline/ButtonIconOutlineMedium';
import ButtonIconGhostSmall from '../../common/ButtonIconGhost/ButtonIconGhostSmall';
import CardItem from '../../card/CardItem/CardItem';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { Popover } from 'antd';
import { filterByKeyAndValue } from '../../../utils/data/list.utils';
import { mapListObjectByKey } from '../../../utils/data/map.utils';
import { roundTo } from '../../../utils/geometry/epsilon';
import {
  convertCodeToName,
  convertTypeToName,
} from '../../../utils/string/string.utils';
import Transition from '../../transition/transition';
import Tag from '../../common/Tag/Tag';
import { Tooltip } from 'antd';
import useDrawerCard from '../../../pages/CartPage/components/DrawerCart/DrawerCart';
import { ShortcutUtils } from '../../../utils/shortcuts/ShortcutUtils';
import TabComponent from '../../common/TabComponent/TabComponent';
import ButtonPrimaryMedium from '../../common/ButtonPrimary/ButtonPrimaryMedium';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const CabinetTrimView = ({ open, designId, onClose }) => {
  const containerId = 'estimated-cost-cabinet-trim';
  const {
    cabinetType,
    FLOOR_TEXTURES,
    fetchModule,
    applyInsideToModule,
    // insideLoaderRef,
    setListModule,
    dataDesign,
    setDataDesign,
    handleUpdateDesign,
    handleSaveAllDesign,
    sceneManager: sceneManagerDesigner,
    handleExport,
    cbTrim,
    setCbTrim,
  } = useContext(DesignerPageContext);
  const { user } = useSelector(state => state.auth);

  const { vnConfig, usConfig } = useSelector(state => state.defaultConfig);

  const { openDrawerCart } = useDrawerCard();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sceneRef = useRef(null);
  const [openDetail, setOpenDetail] = useState(false);

  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  // const designId = searchParams.get('design_id');

  const [sceneManager, setSceneManager] = useState(null);
  const [isLoadingDesign, setIsLoadingDesign] = useState(false);
  const [isDimensioning, setIsDimensioning] = useState(false);
  const insideLoaderRef = useRef(null);
  const [isHideDoor, setIsHideDoor] = useState(false);
  const [showTransition, setShowTransition] = useState(false);

  const [cabinetTrimWidth, setCabinetTrimWidth] = useState(cbTrim.width);
  const [cabinetTrimHeight, setCabinetTrimHeight] = useState(cbTrim.height);

  // Tab active: 'neptu' | 'thietke'
  const [tabActive, setTabActive] = useState('neptu');

  const [isSelectedImage, setIsSelectedImage] = useState();

  const [appearance, setAppearance] = useState({
    wallColor: '#FCFCFC',
    floorTexId: 'wood6', // khớp với /assets/images/texture1.jpg
    floorRepeat: 4,
  });

  const [form] = useForm();

  const calcFloorRepeat = (width = 5, depth = 5, tileMeters = 1.2) => {
    // tileMeters = kích thước “ô” thật của texture (m). Tùy texture bạn chỉnh lại.
    const maxLen = Math.max(width, depth);
    return Math.max(1, Math.ceil(maxLen / tileMeters));
  };

  const startCabinetDesign = () => {
    if (!sceneManager) return;

    try {
      const cabinet = sceneManager.startCabinetDesign(cabinetType);
    } catch (error) {
      console.error(' Error starting cabinet design:', error);
    }
  };

  const loadDesignFromData = async () => {
    try {
      const objectToMap = object =>
        object && typeof object === 'object'
          ? new Map(Object.entries(object))
          : new Map();

      const data = dataDesign;
      // 1) Khôi phục scene nền (tường/sàn) + appearance
      if (data.scene?.export && sceneRef.current?.importSceneData) {
        sceneRef.current.importSceneData(data.scene.export);
      }
      if (
        data.scene?.export?.wallTexture &&
        data.scene?.export?.floorTexture &&
        data.scene?.export?.floorSize
      ) {
        const foundTex = FLOOR_TEXTURES.find(
          texture => texture.img === data.scene?.export?.floorTexture
        );
        // 2) Tính repeat theo kích thước sàn
        const repeatBy = calcFloorRepeat(
          data.floorSize?.width,
          data.floorSize?.depth
        );
        const newAppearance = {
          wallColor: data.scene?.export?.wallTexture || '#FCFCFC',
          floorTexId: foundTex ? foundTex.id : null,
          floorRepeat: repeatBy,
        };
        setAppearance(newAppearance);
      }
      // 2) Khởi tạo cabinet
      if (!sceneManager) {
        openMessageWarning({ content: t('SceneManager is not ready!') });
        return data;
      }
      startCabinetDesign(data.cabinet?.cabinetType || cabinetType);
      // 3) Load lại modules từ API và tái dựng
      for (const module of data.modules || []) {
        try {
          // ===== FETCH MODULE DATA TỪ API (GIỐNG CARDPRODUCT) =====
          const action = await dispatch(fetchModule(module.moduleId));
          if (!action?.payload?.data) {
            console.warn(`Không thể load module ${module.moduleId}`);
            continue;
          }
          let moduleData = action.payload.data;
          moduleData = {
            ...moduleData,
            settings: {
              dimensions: module.dimensions,
              options: module.options,
            },
          };
          if (module.beveled !== undefined) {
            moduleData.beveled = module.beveled;
          }
          if (module.userData !== undefined) {
            moduleData.userData = module.userData;
          }
          // ===== LOAD MODULE VÀO SCENE =====
          const moduleInstance = await sceneManager.loadCabinetModule(
            moduleData,
            module.moduleType
          );

          moduleInstance.textures = objectToMap(module.textures);

          if (!moduleInstance?.group) {
            console.warn(
              `Không thể tạo instance cho module ${module.moduleId}`
            );
            continue;
          }
          // ===== SET TRS CHO GROUP =====
          const group = moduleInstance.group;
          const [px, py, pz] = module.groupTRS.p;
          const [rx, ry, rz] = module.groupTRS.r;
          // const [sx, sy, sz] = m.groupTRS.s;
          group.position.set(px, py, pz);
          group.rotation.set(rx, ry, rz);
          // g.scale.set(sx, sy, sz);
          group.updateMatrixWorld(true);
          // ===== THÊM VÀO POSITION CONTROLLER (GIỐNG ADDCABINETMODULE) =====
          if (sceneManager.positionController) {
            const clonedScene = group.clone();
            clonedScene.children = [
              clonedScene.children?.find(x => x.type === 'Group'),
            ];
            clonedScene.rotation.set(0, 0, 0);
            clonedScene.updateMatrixWorld(true);
            const box = new THREE.Box3().setFromObject(clonedScene);
            const size = new THREE.Vector3();
            box.getSize(size);
            const center = new THREE.Vector3();
            box.getCenter(center);
            sceneManager.positionController.addModule({
              id: group.uuid,
              x: center.x,
              y: center.y - size.y / 2,
              z: center.z,
              width: size.x,
              height: size.y,
              depth: size.z,
              rotate: group.rotation,
              group: moduleInstance.group,
            });
          }
          const currentCabinet =
            sceneManager.cabinetManager.getCurrentCabinet();
          // Load từng inside item
          const payload = module.inside;
          if (module.inside) {
            await applyInsideToModule({
              payload,
              moduleInstance,
              currentCabinet,
              insideLoader: insideLoaderRef.current,
            });

            await sceneManager.textureController.reloadTexture({
              module: moduleInstance,
            });
          }
          // ===== CẬP NHẬT LIST MODULE =====
          setListModule(prev => [...prev, moduleInstance]);
        } catch (error) {
          console.error(`Lỗi khi load module ${module.moduleId}:`, error);
          openMessageError({
            content: t('Failed to load module {{moduleId}}', {
              moduleId: module.moduleId,
            }),
          });
        }
      }
      // ===== TỰ ĐỘNG FIT CEILING (NẾU CÓ UPPER) =====
      // if (data.modules?.some((m) => m.moduleType?.includes("upper"))) {
      //   openModalFitHeight({
      //     func: () => {
      //       sceneManager.autoFitModuleController?.moveCeilingFollowHeightestUpperCabinet(
      //         { insideLoaderRef }
      //       );
      //     },
      //   });
      // }
      // ===== TÍNH TOÁN TỔNG CHI PHÍ =====

      // 4) Khôi phục camera
      if (data.scene?.camera && sceneRef.current?.controls) {
        const camera = data.scene.camera;
        if (camera.position) {
          const [x, y, z] = camera.position;
          sceneRef.current.camera.position.set(x, y, z);
        }
        if (camera.target) {
          const [tx, ty, tz] = camera.target;
          sceneRef.current.controls.target.set(tx, ty, tz);
        }
        sceneRef.current.camera.updateProjectionMatrix?.();
        sceneRef.current.render?.();
      }

      // openMessageSuccess({ content: "Đã load lại thiết kế!" });
      return data;
    } catch (e) {
      console.error('Lỗi khi load thiết kế:', e);
      openMessageError({ content: t('Failed to load design!') });
      return null;
    } finally {
      // await sceneManager.calculateTotalCost?.({});
    }
  };

  const handleScaleModule = (
    isFixedModule,
    currentModule,
    mdDimensions,
    mdOptions
  ) => {
    if (isFixedModule) return;

    //Cập nhật chiều cao nẹp tương ứng cho tủ góc
    if (
      currentModule?.moduleType?.includes('corner') ||
      currentModule?.moduleType?.includes('curve')
    ) {
      mdOptions = { ...mdOptions, caoNep: cabinetTrimHeight };
    }

    try {
      const newData = {
        mdDimensions: {
          ...currentModule.formularController.currentDimensions,
          ...mdDimensions,
        },
        mdOptions: {
          ...currentModule.formularController.currentOptions,
          ...mdOptions,
        },
      };

      const oldDimensions = currentModule.formularController.currentDimensions;
      const oldOptions = currentModule.formularController.currentOptions;

      // Scale module với newData
      currentModule.scaleModuleWithFormular(
        newData.mdDimensions,
        newData.mdOptions
      );

      // Scale inside components
      if (insideLoaderRef?.current) {
        insideLoaderRef?.current.scaleInsideAfterModuleScale(
          currentModule,
          oldDimensions,
          newData.mdDimensions,
          oldOptions,
          newData.mdOptions
        );
      }
    } catch (error) {
      console.error('Error scaling module:', error);
    }
  };

  const handleAutoAddCabinetTrim = async () => {
    const modules = [];
    const currentCabinet = sceneManager.getCurrentCabinet();

    sceneManager.scene.traverse(object => {
      if (
        object.userData?.type === 'module' &&
        // !object.userData?.moduleType?.includes('corner') &&
        !object.userData?.moduleType?.includes('dressingTable') &&
        // !object.userData?.moduleType?.includes('tv') &&
        // !object.userData?.moduleType?.includes('bench') &&
        !object.userData?.moduleType?.includes('curved_block') &&
        !object.userData?.moduleType?.includes('dotke') &&
        !object.userData?.moduleType?.includes('tamopbia')
      ) {
        modules.push(object);
      }
    });

    modules.forEach(md => {
      // const isCeilingModel = sceneManager?.createCabinetTrim?.checkCeiling(
      //   md,
      //   sceneManager.ceiling
      // );

      // const isCeilingModel = sceneManager?.createCabinetTrim?.checkCeiling(
      //   md,
      //   sceneManager.beams[0].mesh
      // );

      //Kiểm tra với cả trần và dầm
      const objectsToCheck = [
        sceneManager.ceiling,
        ...(sceneManager?.beams?.map(b => b.mesh) || []),
      ];

      let isCeilingModel = { collision: false, top: false };

      for (const object of objectsToCheck) {
        const result = sceneManager?.createCabinetTrim?.checkCeiling(
          md,
          object
        );
        if (result?.top) {
          isCeilingModel = result;
          break;
        }
      }

      if (isCeilingModel.collision === true && isCeilingModel.top) {
        md.userData.cabinetTrimPos = {
          ...md.userData.cabinetTrimPos,
          top: true,
        };

        const foundModule = currentCabinet.getModuleByGroupUuid(md.uuid);

        //Kiểm tra xem module có phải module cố định không (kệ chén, hút mùi, ...)
        // const isFixedModule = Boolean(
        //   foundModule.listInside.some(
        //     inside =>
        //       inside.type === InsideType.ACCESSORY_DISH_LOWER ||
        //       inside.type === InsideType.ACCESSORY_DISH_UPPER ||
        //       inside.type === InsideType.ACCESSORY_HOOD
        //   ) || md.userData.cabinetType?.includes('hood')
        // );

        //Cho phép thay đổi scale chiều cao
        const isFixedModule = false;

        handleScaleModule(isFixedModule, foundModule, {
          height:
            // foundModule.formularController.currentDimensions.height - 0.03,
            foundModule.formularController.currentDimensions.height -
            cabinetTrimHeight,
        });

        //Kiểm tra module là ngoài cùng để thêm nẹp nóc bìa (trừ tủ bếp thường)
        if (!md.userData.moduleType?.includes('kitchen')) {
          //Kiểm tra kèm điều kiện cùng depth
          const moduleCollision =
            sceneManager?.createCabinetTrim?.detectModuleWithModuleSameSizeCollision(
              md
            );

          if (moduleCollision === false || !moduleCollision.collision) {
            // Không có va chạm - thêm cho cả 2 bên
            if (md.userData.cabinetTrimPos) {
              md.userData.cabinetTrimPos = {
                ...md.userData.cabinetTrimPos,
                leftmost: true,
                rightmost: true,
              };
            }
          } else {
            if (moduleCollision.left === false) {
              md.userData.cabinetTrimPos = {
                ...md.userData.cabinetTrimPos,
                leftmost: true,
              };
            }
            if (moduleCollision.right === false) {
              md.userData.cabinetTrimPos = {
                ...md.userData.cabinetTrimPos,
                rightmost: true,
              };
            }
          }
        }
      } else {
        md.userData.cabinetTrimPos = {
          ...md.userData.cabinetTrimPos,
          top: false,
        };
      }

      // Kiểm tra va chạm với tường cho từng module
      const wallCollision =
        sceneManager?.createCabinetTrim?.detectModuleWallCollision(md);
      if (wallCollision === false || !wallCollision.collision) {
        // Không có va chạm - xóa trim position
        if (md.userData.cabinetTrimPos) {
          md.userData.cabinetTrimPos = {
            ...md.userData.cabinetTrimPos,
            left: false,
            right: false,
            back: false,
          };
        }
      } else {
        // Có va chạm - set trim position
        if (wallCollision.left) {
          md.userData.cabinetTrimPos.left = true;
        }
        if (wallCollision.right) {
          md.userData.cabinetTrimPos.right = true;
        }
        if (wallCollision.back) {
          md.userData.cabinetTrimPos.back = true;
        }

        if (wallCollision.left || wallCollision.right) {
          const foundModule = currentCabinet.getModuleByGroupUuid(md.uuid);

          //Kiểm tra xem module có phải module cố định không (kệ chén, hút mùi, ...)
          const isFixedModule = Boolean(
            foundModule.listInside.some(
              inside =>
                inside.type === InsideType.ACCESSORY_DISH_LOWER ||
                inside.type === InsideType.ACCESSORY_DISH_UPPER ||
                inside.type === InsideType.ACCESSORY_HOOD
            ) || md.userData.cabinetType?.includes('hood')
          );

          if (wallCollision.left) {
            handleScaleModule(
              isFixedModule,
              foundModule,
              {
                width:
                  foundModule.formularController.currentDimensions.width -
                  cabinetTrimWidth,
              },
              {
                KCCot: Math.max(
                  0,
                  foundModule.formularController.currentOptions.KCCot -
                    cabinetTrimWidth
                ),
                ...(foundModule.formularController.currentOptions.KCCot <=
                  0 && {
                  rongCot:
                    foundModule.formularController.currentOptions.rongCot -
                    cabinetTrimWidth,
                }),
              }
            );
          }

          if (wallCollision.right) {
            if (
              foundModule.formularController.currentOptions.KCCot +
                foundModule.formularController.currentOptions.rongCot >=
              foundModule.formularController.currentDimensions.width
            ) {
              handleScaleModule(
                isFixedModule,
                foundModule,
                {
                  width:
                    foundModule.formularController.currentDimensions.width -
                    cabinetTrimWidth,
                },
                {
                  KCCot: Math.max(
                    0,
                    foundModule.formularController.currentOptions.KCCot -
                      cabinetTrimWidth
                  ),
                  ...(foundModule.formularController.currentOptions.KCCot <=
                    0 && {
                    rongCot:
                      foundModule.formularController.currentOptions.rongCot -
                      cabinetTrimWidth,
                  }),
                }
              );
            } else {
              handleScaleModule(isFixedModule, foundModule, {
                width:
                  foundModule.formularController.currentDimensions.width -
                  cabinetTrimWidth,
              });
            }
          }

          // if (isFixedModule) return;
          let extraCabinetTrimWidth = 0;
          if (isFixedModule) {
            extraCabinetTrimWidth = cabinetTrimWidth / 2;
          }

          const orientation = GeometryUtils.getModuleOrientation(md);

          switch (orientation) {
            case 'NORMAL':
              if (wallCollision.left) {
                md.position.z -= cabinetTrimWidth / 2 + extraCabinetTrimWidth;
              }
              if (wallCollision.right) {
                md.position.z += cabinetTrimWidth / 2 + extraCabinetTrimWidth;
              }
              break;

            case 'ROTATED_90':
              if (wallCollision.left) {
                md.position.x -= cabinetTrimWidth / 2 + extraCabinetTrimWidth;
              }
              if (wallCollision.right) {
                md.position.x += cabinetTrimWidth / 2 + extraCabinetTrimWidth;
              }
              break;

            case 'ROTATED_180':
              if (wallCollision.left) {
                md.position.z += cabinetTrimWidth / 2 + extraCabinetTrimWidth;
              }
              if (wallCollision.right) {
                md.position.z -= cabinetTrimWidth / 2 + extraCabinetTrimWidth;
              }
              break;

            case 'ROTATED_270':
              if (wallCollision.left) {
                md.position.x += cabinetTrimWidth / 2 + extraCabinetTrimWidth;
              }
              if (wallCollision.right) {
                md.position.x -= cabinetTrimWidth / 2 + extraCabinetTrimWidth;
              }
              break;

            default:
              console.warn(`Unknown orientation: ${orientation}`);
              break;
          }
        }
      }
    });
  };

  const handleAutoAddCabinetCover = async () => {
    const modules = [];
    const currentCabinet = sceneManager.getCurrentCabinet();

    sceneManager.scene.traverse(object => {
      if (
        object.userData?.type === 'module' &&
        !object.userData?.moduleType?.includes('corner') &&
        !object.userData?.moduleType?.includes('curved_block')
      ) {
        modules.push(object);
      }
    });

    modules.forEach(md => {
      // Kiểm tra va chạm với những module khác cho từng module chỉ áp dụng với tủ bếp (trừ đảo bếp)
      if (
        md.userData.cabinetType?.includes('kitchen') &&
        !md.userData.moduleType?.includes('kitchen_island') &&
        !md.userData.moduleType?.includes('totl') &&
        !md.userData.moduleType?.includes('cabinet_dry') &&
        !md.userData.moduleType?.includes('present')
      ) {
        //Thu nhỏ module bằng đúng độ dày ốp bìa
        const cabinetCoverThickness = 0.017; // 17mm
        const foundModule = currentCabinet.getModuleByGroupUuid(md.uuid);

        const moduleCollision =
          sceneManager?.createCabinetTrim?.detectModuleWithModuleCollision(md);

        //Kiểm tra xem module có phải module cố định không (kệ chén, hút mùi, ...)
        const isFixedModule = Boolean(
          foundModule.listInside.some(
            inside =>
              inside.type === InsideType.ACCESSORY_DISH_LOWER ||
              inside.type === InsideType.ACCESSORY_DISH_UPPER ||
              inside.type === InsideType.ACCESSORY_HOOD
          ) || md.userData.cabinetType?.includes('hood')
        );

        md.userData.cabinetCoverPos = {
          left: true,
          right: true,
        };

        if (moduleCollision === false || !moduleCollision.collision) {
          // Không có va chạm - xóa cover position
          // if (md.userData.cabinetCoverPos) {
          //   md.userData.cabinetCoverPos = {
          //     ...md.userData.cabinetCoverPos,
          //     left: false,
          //     right: false,
          //   };
          // }

          if (md.userData.cabinetTrimPos) {
            if (md.userData.cabinetTrimPos?.left !== true) {
              handleScaleModule(isFixedModule, foundModule, {
                width:
                  foundModule.formularController.currentDimensions.width -
                  cabinetCoverThickness,
              });

              md.userData.cabinetCoverPos = {
                ...md.userData.cabinetCoverPos,
                left: false,
              };
            }

            if (md.userData.cabinetTrimPos?.right !== true) {
              handleScaleModule(isFixedModule, foundModule, {
                width:
                  foundModule.formularController.currentDimensions.width -
                  cabinetCoverThickness,
              });

              md.userData.cabinetCoverPos = {
                ...md.userData.cabinetCoverPos,
                right: false,
              };
            }
          }
        } else {
          // Có va chạm - set cover position
          md.userData.cabinetCoverPos.left = moduleCollision.left;
          md.userData.cabinetCoverPos.right = moduleCollision.right;

          //Kiểm tra điều kiện để thêm ốp bìa
          const isCabinetCoverLeft =
            moduleCollision.left === false &&
            md.userData.cabinetTrimPos?.left !== true;
          const isCabinetCoverRight =
            moduleCollision.right === false &&
            md.userData.cabinetTrimPos?.right !== true;

          if (isCabinetCoverLeft) {
            handleScaleModule(isFixedModule, foundModule, {
              width:
                foundModule.formularController.currentDimensions.width -
                cabinetCoverThickness,
            });
          }

          if (isCabinetCoverRight) {
            handleScaleModule(isFixedModule, foundModule, {
              width:
                foundModule.formularController.currentDimensions.width -
                cabinetCoverThickness,
            });
          }

          // if (isFixedModule) return;
          let extraMove = 0;
          if (isFixedModule) {
            extraMove = cabinetCoverThickness / 2;
          }

          const orientation = GeometryUtils.getModuleOrientation(md);

          switch (orientation) {
            case 'NORMAL':
              if (isCabinetCoverLeft) {
                md.position.z -= cabinetCoverThickness / 2 + extraMove;
              }
              if (isCabinetCoverRight) {
                md.position.z += cabinetCoverThickness / 2 + extraMove;
              }
              break;

            case 'ROTATED_90':
              if (isCabinetCoverLeft) {
                md.position.x -= cabinetCoverThickness / 2 + extraMove;
              }
              if (isCabinetCoverRight) {
                md.position.x += cabinetCoverThickness / 2 + extraMove;
              }
              break;

            case 'ROTATED_180':
              if (isCabinetCoverLeft) {
                md.position.z += cabinetCoverThickness / 2 + extraMove;
              }
              if (isCabinetCoverRight) {
                md.position.z -= cabinetCoverThickness / 2 + extraMove;
              }
              break;

            case 'ROTATED_270':
              if (isCabinetCoverLeft) {
                md.position.x += cabinetCoverThickness / 2 + extraMove;
              }
              if (isCabinetCoverRight) {
                md.position.x -= cabinetCoverThickness / 2 + extraMove;
              }
              break;

            default:
              console.warn(`Unknown orientation: ${orientation}`);
              break;
          }
        }
      }
    });
  };

  const handleFitModulesAroundFixed = async (
    distanceMove = 0.017,
    maxDepth = 10,
    currentDepth = 0
  ) => {
    if (currentDepth >= maxDepth) {
      console.warn('Đạt giới hạn đệ quy tối đa');
      return;
    }

    const modules = [];
    const currentCabinet = sceneManager.getCurrentCabinet();

    sceneManager.scene.traverse(object => {
      if (
        object.userData?.type === 'module' &&
        // !object.userData?.moduleType?.includes('tv') &&
        // !object.userData?.moduleType?.includes('bench') &&
        !object.userData?.moduleType?.includes('curved_block')
      ) {
        modules.push(object);
      }
    });

    let hasAnyCollision = false;

    for (const md of modules) {
      if (
        !md.userData.cabinetType?.includes('kitchen') ||
        md.userData.moduleType?.includes('kitchen_island') ||
        md.userData.moduleType?.includes('totl') ||
        md.userData.moduleType?.includes('cabinet_dry') ||
        md.userData.moduleType?.includes('present')
      ) {
        continue;
      }

      const subWidth = distanceMove; // khoảng trừ để vừa với nẹp
      // const subWidth = cabinetTrimWidth; // 30mm, khoảng trừ để vừa với nẹp
      // const subWidth = 0.017; // 17mm độ dày tấm ốp bìa
      let moveExtra = 0; // khoảng di chuyển thêm đối với module cố định ( sẽ thành subWidth/2 nếu là module cố định)

      const foundModule = currentCabinet.getModuleByGroupUuid(md.uuid);
      if (!foundModule) continue;

      const isFixedModule = Boolean(
        foundModule.listInside.some(
          inside =>
            inside.type === InsideType.ACCESSORY_DISH_LOWER ||
            inside.type === InsideType.ACCESSORY_DISH_UPPER ||
            inside.type === InsideType.ACCESSORY_HOOD
        ) || md.userData.cabinetType?.includes('hood')
      );

      if (!isFixedModule) continue;

      // Lấy ra module va chạm với module cố định
      const collidingModule =
        sceneManager?.createCabinetTrim?.detectCollidingModules(md);

      if (!collidingModule) continue;

      const foundCollidingModule = currentCabinet.getModuleByGroupUuid(
        collidingModule.module.uuid
      );

      if (!foundCollidingModule) continue;

      const isFixedCollidingModule = Boolean(
        foundCollidingModule.listInside.some(
          inside =>
            inside.type === InsideType.ACCESSORY_DISH_LOWER ||
            inside.type === InsideType.ACCESSORY_DISH_UPPER ||
            inside.type === InsideType.ACCESSORY_HOOD
        ) || collidingModule.module.userData.cabinetType?.includes('hood')
      );

      //Nếu module va chạm cũng là module cố định thì chỉ move mà không scale
      if (isFixedCollidingModule) {
        // Vẫn còn va chạm → đánh dấu để đệ quy lại
        hasAnyCollision = true;

        moveExtra = subWidth / 2;
      } else {
        handleScaleModule(false, foundCollidingModule, {
          width:
            foundCollidingModule.formularController.currentDimensions.width -
            subWidth,
        });
      }

      if (collidingModule.collision !== true) continue;
      //Nếu là module có nẹp bìa thì không được phép di chuyển
      if (
        collidingModule.module.userData?.cabinetTrimPos?.left === true ||
        collidingModule.module.userData?.cabinetTrimPos?.right === true
      ) {
        continue;
      }

      const orientation = GeometryUtils.getModuleOrientation(
        collidingModule.module
      );
      const { left, right } = collidingModule;

      switch (orientation) {
        case 'NORMAL':
          if (left)
            collidingModule.module.position.z += subWidth / 2 + moveExtra;
          if (right)
            collidingModule.module.position.z -= subWidth / 2 + moveExtra;
          break;

        case 'ROTATED_90':
          if (left)
            collidingModule.module.position.x += subWidth / 2 + moveExtra;
          if (right)
            collidingModule.module.position.x -= subWidth / 2 + moveExtra;
          break;

        case 'ROTATED_180':
          if (left)
            collidingModule.module.position.z -= subWidth / 2 + moveExtra;
          if (right)
            collidingModule.module.position.z += subWidth / 2 + moveExtra;
          break;

        case 'ROTATED_270':
          if (left)
            collidingModule.module.position.x -= subWidth / 2 + moveExtra;
          if (right)
            collidingModule.module.position.x += subWidth / 2 + moveExtra;
          break;

        default:
          console.warn(`Unknown orientation: ${orientation}`);
          break;
      }
    }

    // Còn va chạm → đệ quy lại từ đầu
    if (hasAnyCollision) {
      console.log(`Depth ${currentDepth + 1}: vẫn còn va chạm, đệ quy lại...`);
      await handleFitModulesAroundFixed(
        distanceMove,
        maxDepth,
        currentDepth + 1
      );
    } else {
      console.log(`Hoàn thành sau ${currentDepth + 1} lần đệ quy`);
    }
  };

  const handleOtherKeyPress = useCallback(
    async e => {
      if (e.altKey && e.code === 'KeyD') {
        // xử lý dim kích thước ở đây
        setIsDimensioning(prev => {
          if (sceneManager)
            if (prev) {
              sceneManager.clearAllCornerPoints();
            } else {
              sceneManager.generateCornerPoints();
            }
          return !prev;
        });
      }
      if (e.altKey && e.code === 'KeyQ') {
        // xử lý tính khoảng cách ở đây
        sceneManager.positionController.createDistanceLines();
      }
      if (e.code === 'KeyH') {
        // xử lý ẩn hiện cửa ở đây
        setIsHideDoor(prev => {
          if (sceneManager) {
            // ShortcutUtils.visibleDoor(prev, isOpenDoor, sceneManager);
            ShortcutUtils.visibleDoor(prev, false, sceneManager);

            return !prev;
          }
        });
      }
    },
    [sceneManager]
  );

  const renderUIInfoNepTu = active => {
    return (
      <div
        className={cn(
          'flex flex-col self-stretch gap-[16px] grow overflow-auto',
          !active &&
            'opacity-0 absolute pointer-events-none top-0 left-0 z-[-1]'
        )}
      >
        <h2 className="text-title-medium empasized">
          {t('Add trim around cabinet')}
        </h2>
        <div
          className="flex p-12 items-start gap-8 self-stretch rounded-[4px]"
          style={{ backgroundColor: '#F2F8FD' }}
        >
          <div className="flex w-24 h-24" style={{ color: '#258FD2' }}>
            <Icon.ICInfo />
          </div>

          <div className="flex flex-col items-start gap-6 self-stretch">
            <span className="lg:text-headline-small text-title-small">
              {t('Mandatory section.')}
            </span>
            <p className="text-body-medium">
              {t(
                'The system has automatically added trims around the cabinet in your design to ensure aesthetics and installation feasibility.'
              )}
            </p>
          </div>
        </div>
        <ol className="ps-16 list-decimal">
          <li className="text-body-medium">
            <Trans
              i18nKey={
                '<strong>Enhance aesthetics:</strong> Trims help cover gaps, joints, or imperfections on the cabinet edges, creating a seamless and elegant look for the overall interior.'
              }
              components={{ strong: <strong /> }}
            />
          </li>

          <li className="text-body-medium">
            <Trans
              i18nKey={
                "<strong>Protect cabinet edges:</strong> Cabinet edges are often prone to scratches and wear from impacts. Trims help protect these edges from damage, extending the product's lifespan."
              }
              components={{ strong: <strong /> }}
            />
          </li>

          <li className="text-body-medium">
            <Trans
              i18nKey={
                '<strong>Secure structure:</strong> Some types of trims also serve the function of securing the joined parts, helping to make the cabinet more solid during use.'
              }
              components={{ strong: <strong /> }}
            />
          </li>
        </ol>
      </div>
    );
  };

  const renderUIInfoThietKe = active => {
    return (
      <div
        className={cn(
          'flex flex-col self-stretch gap-[16px] grow overflow-auto',
          !active &&
            'opacity-0 absolute pointer-events-none top-0 left-0 z-[-1]'
        )}
      >
        <h2 className="text-title-medium empasized">{t('Design')}</h2>
        <div className="flex flex-col items-start gap-[8px]">
          <div
            className={cn(
              `flex w-[120px] h-[120px] rounded-[8px] border-[1px] border-solid border-[#E6E7E7] bg-[lightgray] bg-center bg-cover bg-no-repeat hover:border-[2px] hover:border-[#FFC914] transition-all duration-200 cursor-pointer`,
              isSelectedImage && 'border-[#FFC914]'
            )}
            style={{
              backgroundImage: `url('https://d1f1x7hanba063.cloudfront.net/applications/erp/images/room_thumbnail_KVxIqZB.jpg')`,
            }}
          ></div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (
      sceneManager &&
      vnConfig.priceConfig?.data &&
      vnConfig.profitConfig?.data &&
      vnConfig.ruleConfig?.data
    ) {
      sceneManager.updateDefaultViPriceConfig({
        priceConfig: vnConfig.priceConfig.data,
        profitConfig: vnConfig.profitConfig.data,
        ruleConfig: vnConfig.ruleConfig.data,
      });
    }
  }, [
    sceneManager,
    vnConfig.priceConfig?.data,
    vnConfig.profitConfig?.data,
    vnConfig.ruleConfig?.data,
  ]);

  useEffect(() => {
    if (
      sceneManager &&
      usConfig.priceConfig?.data &&
      usConfig.profitConfig?.data &&
      usConfig.ruleConfig?.data
    ) {
      sceneManager.updateDefaultUsPriceConfig({
        priceConfig: usConfig.priceConfig.data,
        profitConfig: usConfig.profitConfig.data,
        ruleConfig: usConfig.ruleConfig.data,
      });
    }
  }, [
    sceneManager,
    usConfig.priceConfig?.data,
    usConfig.profitConfig?.data,
    usConfig.ruleConfig?.data,
  ]);

  useEffect(() => {
    const onKey = async e => {
      // Ignore input fields
      const activeElement = document.activeElement;
      const isTyping =
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.isContentEditable;

      if (isTyping) {
        return; // Không làm gì, để người dùng xóa text bình thường
      }

      await handleOtherKeyPress(e);
    };

    document.addEventListener('keydown', onKey);

    return () => document.removeEventListener('keydown', onKey);
  }, [handleOtherKeyPress]);

  useEffect(() => {
    if (open) {
      const scene = new ExtendedSceneManager('cabinetTrim');
      //update lại thông số nẹp
      scene.createCabinetTrim.updateCabinetTrimSettings(cbTrim);
      scene.nestingController.updateCabinetTrimSettings(cbTrim);

      scene.initialize({
        type: 'wall',
        draggable: false,
        containerId: 'container__cabinetTrim',
      });

      sceneRef.current = scene;

      insideLoaderRef.current = new InsideLoader(scene);

      //Xác định loại cabinet cho insideLoader
      insideLoaderRef.current.setCabinetType(cabinetType);
      dispatch(fetchPricePermanents()).then(action => {
        if (action.payload?.data) {
          const { data } = action.payload;

          // scene.updatePrice(data);
        }
      });

      setSceneManager(scene);

      // const result = sceneManagerDesigner?.getResultEstimatePrice();
      // if (result) {
      //   if (result.noTexture) {
      //     openNotification({
      //       key: 'no-texture-warning',
      //       icon: <Icon.ICWarning />,
      //       iconColor: '#F97D16',
      //       title: t('Texture not selected'),
      //       description: t(
      //         'Please select materials for all designs before saving to the library.'
      //       ),
      //       placement: 'bottomRight',
      //       closable: true,
      //     });
      //   }
      //   if (result.noGlass) {
      //     openNotification({
      //       key: 'no-glass-warning',
      //       icon: <Icon.ICWarning />,
      //       iconColor: '#F97D16',
      //       title: t('Glass not selected'),
      //       description: t(
      //         'Please select glass for all doors before saving to the library.'
      //       ),
      //       placement: 'bottomRight',
      //       closable: true,
      //     });
      //   }
      // }

      return () => {
        scene.dispose();
        sceneRef.current = null;
        setDataDesign(null);
      };
    } else {
      if (sceneRef.current !== null) {
        sceneRef.current.dispose();
        sceneRef.current = null;
        setDataDesign(null);
      }
    }
  }, [open]);

  useEffect(() => {
    if (sceneManager && dataDesign) {
      sceneManager?.updateDataCountertopAndBacksplash(
        dataDesign.countertop,
        dataDesign.backsplash,
        dataDesign.ledDecor
      );

      setIsLoadingDesign(true);
      loadDesignFromData()
        .then(async () => {
          // Hoàn thiện MB,VB trước khi trừ hao nẹp
          await sceneManager?.updateAllCountertopAndBacksplash();

          await handleAutoAddCabinetTrim()
            .then(async () => {
              sceneManager?.updateAllCabinetTrim();

              await handleFitModulesAroundFixed(cabinetTrimWidth);
            })
            .catch(error => {
              console.error('Lỗi khi tự động trừ hao nẹp:', error);
            });

          await handleAutoAddCabinetCover()
            .then(async () => {
              await sceneManager?.updateAllCabinetCover();

              await handleFitModulesAroundFixed(0.017);

              setTimeout(async () => {
                const result = await sceneManager?.calculateTotalCost({
                  containerId,
                });
                if (result) {
                  if (result.noTexture) {
                    openNotification({
                      key: 'no-texture-warning',
                      icon: <Icon.ICWarning />,
                      iconColor: '#F97D16',
                      title: t('Texture not selected'),
                      description: t(
                        'Please select materials for all designs before saving to the library.'
                      ),
                      placement: 'bottomRight',
                      closable: true,
                    });
                  }
                  if (result.noGlass) {
                    openNotification({
                      key: 'no-glass-warning',
                      icon: <Icon.ICWarning />,
                      iconColor: '#F97D16',
                      title: t('Glass not selected'),
                      description: t(
                        'Please select glass for all doors before saving to the library.'
                      ),
                      placement: 'bottomRight',
                      closable: true,
                    });
                  }
                  if (result.noAlum) {
                    openNotification({
                      key: 'no-alum-warning',
                      icon: <Icon.ICWarning />,
                      iconColor: '#F97D16',
                      title: t('Aluminum not selected'),
                      description: t(
                        'Please select aluminum for all doors before saving to the library.'
                      ),
                      placement: 'bottomRight',
                      closable: true,
                    });
                  }
                }

                sceneManager?.handleDrawBorder();
                setIsLoadingDesign(false);
              }, 1000);
            })
            .catch(error => {
              console.error('Lỗi khi tự động thêm ốp bìa tủ bếp:', error);
            });

          await handleFitModulesAroundFixed()
            .then(async () => {
              setTimeout(async () => {
                const handleCalculate = async () => {
                  let result = await sceneManager?.calculateTotalCost({
                    containerId,
                  });

                  if (result) {
                    if (result.noTexture) {
                      openNotification({
                        key: 'no-texture-warning',
                        icon: <Icon.ICWarning />,
                        iconColor: '#F97D16',
                        title: t('Texture not selected'),
                        description: t(
                          'Please select materials for all designs before saving to the library.'
                        ),
                        placement: 'bottomRight',
                        closable: true,
                      });
                    }
                    if (result.noGlass) {
                      openNotification({
                        key: 'no-glass-warning',
                        icon: <Icon.ICWarning />,
                        iconColor: '#F97D16',
                        title: t('Glass not selected'),
                        description: t(
                          'Please select glass for all doors before saving to the library.'
                        ),
                        placement: 'bottomRight',
                        closable: true,
                      });
                    }
                    if (result.noAlum) {
                      openNotification({
                        key: 'no-alum-warning',
                        icon: <Icon.ICWarning />,
                        iconColor: '#F97D16',
                        title: t('Aluminum not selected'),
                        description: t(
                          'Please select aluminum for all doors before saving to the library.'
                        ),
                        placement: 'bottomRight',
                        closable: true,
                      });
                    }
                  }

                  sceneManager?.handleDrawBorder();
                };

                await handleCalculate();
                setTimeout(async () => {
                  await handleCalculate();
                }, 1000);
                setIsLoadingDesign(false);
              }, 500);
            })
            .catch(error => {
              console.error(
                'Lỗi khi tự động chỉnh kích thước module va chạm với tủ cố định:',
                error
              );
            });
        })
        .catch(error => {
          setIsLoadingDesign(false);
          console.error('Lỗi khi load design:', error);
        });
    }
  }, [sceneManager, dataDesign]);

  useEffect(() => {
    if (!sceneRef.current) return;
    const scene = sceneRef.current;
    const tex = FLOOR_TEXTURES.find(
      texture => texture.id === appearance.floorTexId
    );
    scene.updateWallColor(appearance.wallColor);
    if (tex)
      scene.updateFloorTextureFromImage(tex.img, {
        repeatBy: appearance.floorRepeat,
      });
  }, [appearance]);

  return (
    <>
      <BottomSheet
        classNames={{
          title: 'flex justify-between self-stretch items-center',
          body: '!p-0 gap-0',
        }}
        styles={{
          body: { backgroundColor: '#F5F5F5' },
        }}
        title={
          <RenderHeader
            sceneManager={sceneManager}
            onClose={onClose}
            designId={designId}
            setShowTransition={setShowTransition}
          />
        }
        open={open}
        onClose={() => {
          onClose();
        }}
      >
        <div className="flex p-[24px] content-center items-start self-stretch grow gap-[8px] overflow-hidden">
          <div className="flex flex-col items-start min-w-[200px] p-[16px] gap-[8px] bg-fills-white rounded-[16px] self-stretch">
            <ButtonSelect
              active={tabActive === 'neptu'}
              label={t('Cabinet trim')}
              onClick={() => setTabActive('neptu')}
            />
            {/* <ButtonSelect
              active={tabActive === 'thietke'}
              label={t('Design')}
              onClick={() => setTabActive('thietke')}
            /> */}
          </div>
          <div className="flex items-start self-stretch p-[24px] gap-[24px] grow bg-fills-white rounded-[16px] overflow-hidden">
            <div className="gap-24 self-stretch overflow-hidden flex flex-col min-w-[200px] w-[200px]">
              {renderUIInfoNepTu(tabActive === 'neptu')}
              {renderUIInfoThietKe(tabActive === 'thietke')}
            </div>

            <div
              id="container__cabinetTrim"
              className="relative rounded-[16px] bg-[#F5F5F5]"
            >
              {open && (
                <canvas
                  id="cabinetTrim"
                  className={cn(
                    'w-[100vh] h-[100vh] transition-all duration-300',
                    tabActive === 'neptu'
                      ? 'opacity-100'
                      : 'opacity-0 absolute top-0 left-0 z-[-1]'
                  )}
                />
              )}
              <div
                className={cn(
                  'flex absolute left-16 bottom-16',
                  tabActive === 'neptu' ? 'opacity-100' : 'opacity-0 z-[-1]'
                )}
              >
                <ToolbarDesign
                  sceneManager={sceneManager}
                  isDimensioning={isDimensioning}
                  setIsDimensioning={setIsDimensioning}
                  isHideDoor={isHideDoor}
                  setIsHideDoor={setIsHideDoor}
                />
              </div>

              <img
                src="https://d1f1x7hanba063.cloudfront.net/applications/erp/images/room_thumbnail_KVxIqZB.jpg"
                className={cn(
                  'h-full object-contain transition-all duration-300',
                  tabActive === 'thietke'
                    ? 'opacity-100'
                    : 'opacity-0 absolute top-0 left-0 z-[-1]'
                )}
              />
            </div>
          </div>
        </div>
      </BottomSheet>
      <Transition
        open={showTransition}
        onClose={() => setShowTransition(false)}
        id={'estimated-cost-cabinet-trim-container'}
        sceneManager={sceneManager}
      />
      <LoadingOverlay
        visible={isLoadingDesign}
        text={t('Auto adding trim and completing design')}
      />
    </>
  );
};

export default CabinetTrimView;

const RenderHeader = ({
  onClose,
  sceneManager,
  designId,
  setShowTransition,
}) => {
  const containerId = 'estimated-cost-cabinet-trim';
  const { dataDesign, handleUpdateDesign, handleSaveAllDesign } =
    useContext(DesignerPageContext);
  const { user } = useSelector(state => state.auth);

  const { openDrawerCart } = useDrawerCard();

  const dispatch = useDispatch();
  const [openDetail, setOpenDetail] = useState(false);

  const { t } = useTranslation();
  // const designId = searchParams.get('design_id');

  const [form] = useForm();

  const handleSave = useCallback(async () => {
    if (designId) {
      await handleUpdateDesign(sceneManager);
    } else {
      await handleSaveAllDesign({
        complete: false,
        customSceneManager: sceneManager,
        containerId,
      });
    }
  }, [designId, sceneManager]);

  const handleSaveAndAddToCart = useCallback(async () => {
    if (designId) {
      await handleUpdateDesign(sceneManager);
      await dispatch(addToCart({ designId })).then(() => {
        openMessageSuccess({
          content: t('Added design to cart!'),
        });
        openDrawerCart();
      });
    } else {
      const designId = await handleSaveAllDesign({
        complete: false,
        customSceneManager: sceneManager,
        containerId,
      });
      await dispatch(addToCart({ designId })).then(() => {
        openMessageSuccess({
          content: t('Added design to cart!'),
        });
        openDrawerCart();
      });
    }
  }, [designId, sceneManager]);

  const handleSaveAs = useCallback(async () => {
    if (designId) {
      const result = openModal({
        title: (
          <div className="flex justify-between items-center self-stretch">
            <h4>{t('Save as')}...</h4>
          </div>
        ),
        content: (
          <>
            <Divider type="horizontal" className="!p-0 m-0" />
            <Form layout="vertical" className="px-24 py-16" form={form}>
              <Form.Item label={t('Set name')} name={'nameDesignNew'}>
                <InputComponent placeholder={t('Enter name')} size="large" />
              </Form.Item>
            </Form>
            <Divider type="horizontal" className="!p-0 m-0" />
          </>
        ),
        centered: true,
        width: 538,
        classNames: {
          header: '!p-24 !m-0',
          body: '!p-0 !gap-0',
          footer: '!p-24 !gap-16 !items-end !flex !justify-end',
        },
        footer: (
          <div className="flex justify-end items-center gap-16 self-stretch">
            <ButtonSecondaryLarge
              title={t('Cancel')}
              onClick={() => result.destroy()}
            />
            <ButtonPrimaryLarge
              title={t('Save')}
              onClick={async () => {
                await form.validateFields().then(async values => {
                  const nameDesignNew = values.nameDesignNew;
                  await handleSaveAllDesign({
                    complete: false,
                    customSceneManager: sceneManager,
                    nameDesignNew,
                    containerId,
                  });
                });
                result.destroy();
              }}
            />
          </div>
        ),
      });
    }
  }, [designId, sceneManager, form]);

  return (
    <div className="wall-titlebar">
      <div className="flex items-center self-stretch gap-[12px]">
        <ButtonIconOutlineLarge
          type="button"
          onClick={() => onClose?.()}
          icon={<Icon.ICArrowBack />}
        />

        <span className="text-headline-small">{t('Completed design')}</span>
      </div>
      <div className="flex items-center gap-16 self-stretch">
        <div className="Estimated-cost">
          <span
            className="text-label-small"
            style={{ color: '#818589' }}
            onClick={() => {
              const result = sceneManager?.calculateTotalCost({ containerId });
            }}
          >
            {t('Total price')}
          </span>
          <div
            className="flex items-center"
            style={{ gap: '8px', color: '#5A5D60' }}
          >
            <span className="text-title-large flex items-center gap-4">
              <div className="flex gap-[2px] items-center justify-center">
                <span
                  id="estimated-cost-cabinet-trim"
                  className="text-title-medium"
                ></span>
                <span
                  id="estimated-cost-cabinet-trim-special"
                  className="text-title-medium text-Accents-Red"
                ></span>
                {/* {roundTo(totalPrice?.total, 0).toLocaleString('vi-VN')} */}
              </div>
              <span className="text-body-medium" style={{ color: '#818589' }}>
                ₫
              </span>
            </span>

            {process.env.NODE_ENV === 'development' || isStaff(user) ? (
              <>
                <Tag
                  onClick={() => setShowTransition(true)}
                  style={{ background: '#F5F6F6' }}
                  label={
                    <span className="w-14 h-14 flex">
                      <Icon.ICDesign />
                    </span>
                  }
                />
                {/* <ButtonPrimaryLarge
                        title={'Excel'}
                        posIcon={<Icon.ICProcurement />}
                        onClick={() => {
                          handleExport(sceneManager);
                        }}
                      /> */}
              </>
            ) : (
              <></>
            )}

            <Popover
              getPopupContainer={() => document.body}
              destroyOnHidden={true}
              content={
                <RenderPopup
                  setOpen={setOpenDetail}
                  sceneManager={sceneManager}
                />
              }
              trigger="click"
              styles={{
                body: { width: '520px', maxHeight: '720px' },
              }}
              classNames={{ body: '!p-0 overflow-hidden' }}
              title={
                <div
                  className="flex p-16 justify-between items-center self-stretch"
                  style={{ borderBottom: '1px solid #E6E7E7' }}
                >
                  <span className="text-title-large">{t('Products')}</span>
                  <ButtonIconOutlineMedium
                    icon={<Icon.ICClose />}
                    onClick={() => setOpenDetail(false)}
                  />
                </div>
              }
              open={openDetail}
              onOpenChange={setOpenDetail}
            >
              <ButtonIconGhostSmall
                icon={<Icon.ICList />}
                style={{ border: '1px solid #CFD1D2 ' }}
              />
            </Popover>
          </div>
        </div>
        {/* {!designId && (
                <ButtonPrimaryLarge
                  title={t('Save design')}
                  posIcon={<Icon.ICSave />}
                  style={{ width: '100%' }}
                  onClick={() => handleSaveAllDesign(false, sceneManager)}
                />
              )} */}
        {designId && (
          <>
            <ButtonSecondaryLarge
              title={`${t('Save as')}...`}
              posIcon={<Icon.ICSaveAs />}
              onClick={() => {
                handleSaveAs();
              }}
            />
          </>
        )}
        <ButtonPrimaryLarge
          title={t('Save design')}
          posIcon={<Icon.ICSave />}
          onClick={() => handleSave()}
        />
        <ButtonPrimaryLarge
          style={{ width: '100%' }}
          title={t('Save and add to cart')}
          posIcon={<Icon.ICCart />}
          disabled={!dataDesign?.is_completed}
          onClick={() => {
            handleSaveAndAddToCart();
          }}
        />
      </div>
    </div>
  );
};

const RenderPopup = ({ setOpen, sceneManager }) => {
  const containerId = 'estimated-cost-cabinet-trim';
  const [woodProducts, setWoodProduct] = useState([]);
  const [curveProducts, setCurveProduct] = useState([]);
  const [totalPrice, setTotalPrice] = useState({});
  const [count, setCount] = useState({});
  const [accessories, setAccessories] = useState([]);
  const [ledsDecor, setLedsDecor] = useState(0);
  const [lightSwitches, setLightSwitches] = useState(0);
  const [ledDrivers, setLedDrivers] = useState(0);
  const [countertop, setCountertop] = useState();
  const [backsplash, setBacksplash] = useState();
  const [mapModule, setMapModule] = useState([]);
  const [specialTexture, setSpecialTexture] = useState(false);
  const [tab, setTab] = useState('wood');

  const { handleSaveAllDesign, setShowCabinetTrimView } =
    useContext(DesignerPageContext);

  const { t } = useTranslation();

  useEffect(() => {
    const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
    if (modules) {
      const listModule = Array.from(modules).map(([, item]) => {
        return {
          id: item.id,
          cabinetType: item.cabinetType,
          material: item.material,
          thumbnail_url: item.thumbnail_url,
          moduleData: item.moduleData,
          type: item.cabinet?.type,
          textures: item.textures,
          listInside: item.listInside,
        };
      });

      const resultFilterWoodProducts = filterByKeyAndValue(
        'material',
        'wood',
        listModule
      );
      const resultMapObject = mapListObjectByKey(
        'cabinetType',
        resultFilterWoodProducts
      );
      setMapModule([...Object.entries(resultMapObject)]);
      setWoodProduct([...resultFilterWoodProducts]);

      const tempCount = {};
      const country_code = process.env.REACT_APP_COUNTRY_CODE;
      const result = sceneManager?.getResultEstimatePrice();

      const registryCost = result?.registryCost?.[country_code];
      const registrySale = result?.registrySale?.[country_code];
      const aggregatedSaleTotals = result?.aggregatedSaleTotals?.[country_code];
      const detailSaleTotals = result?.detailSaleTotals?.[country_code];
      const totalPrice = {
        ...result?.total,
        costCurveBlocks: detailSaleTotals?.special?.curveBlocks,
        costEquipments: detailSaleTotals?.special?.equipments?.total,
        costFrame:
          aggregatedSaleTotals?.accessory +
          aggregatedSaleTotals?.component +
          aggregatedSaleTotals?.doors +
          aggregatedSaleTotals?.labor +
          aggregatedSaleTotals?.materials,
      };

      if (result) {
        setSpecialTexture(result?.useSpecialTexture ?? false);
        setTotalPrice(totalPrice);

        tempCount['hinge'] =
          Number(registryCost?.component?.hinges?.[0]?.quantity) +
          Number(registryCost?.component?.hinges135?.[0]?.quantity); //Bản lề

        tempCount['connector'] = Number(
          registryCost?.component?.connectors?.[0]?.quantity
        ); //Chốt cam

        // setCountConnector(result.countConnector); //Chốt cam

        tempCount['rail'] = Number(
          registryCost?.component?.rails?.[0]?.quantity
        ); //Ray

        // setCountRail(result.countRail); //Ray
        setCount({ ...tempCount });

        setAccessories(
          registryCost?.special?.equipments
            .filter(item => item.cost)
            .map(item => ({
              name: item.name,
              price: item.unitPrice,
              material: item.material,
              count: Number(item.quantity) ?? 0,
              thumbnail_url: item.thumbnail_url,
            }))
            .reduce((prev, curr) => {
              const temp = [...prev];
              const index = temp.findIndex(
                i => i.name === curr.name && i.quantity === curr.quantity
              );
              if (index > -1) {
                temp[index].count += 1;
              } else {
                temp.push({ ...curr, count: 1 });
              }
              return temp;
            }, [])
            ?.sort(
              (a, b) =>
                !a.name?.localeCompare(b.name, 'vi', {
                  sensitivity: 'base',
                })
            )
        );

        // let leds = (result?.leds ?? []).reduce((prev, curr) => {
        //   const index = prev.findIndex(
        //     i => i.length === curr.length && i.name === curr.name
        //   );
        //   if (index >= 0) {
        //     const arr = [...prev];
        //     arr[index] = {
        //       ...arr[index],
        //       quantity: arr[index].quantity + 1,
        //     };
        //     return arr;
        //   }
        //   return [...prev, { ...curr, quantity: 1 }];
        // }, []);

        if (registryCost.accessory.ledsDecor) {
          setLedsDecor(
            registryCost.accessory.ledsDecor?.reduce(
              (prev, curr) => prev + Number(curr.quantity),
              0
            ) ?? 0
          );
        } else {
          setLedsDecor(0);
        }
        setLedDrivers(
          registryCost?.accessory?.ledDrivers?.reduce(
            (prev, curr) => prev + Number(curr.quantity),
            0
          ) ?? 0
        );
        setLightSwitches(
          registryCost?.accessory?.lightSwitches?.reduce(
            (prev, curr) => prev + Number(curr.quantity),
            0
          ) ?? 0
        );
        setCurveProduct(aggregatedSaleTotals?.special?.curveBlocks ?? 0);
      }

      const countertopTexture = sceneManager.countertop?.texture;
      if (countertopTexture) {
        setCountertop({
          thumbnail_url: countertopTexture.url,
          name: countertopTexture.textureCode,
          width:
            registryCost?.special?.countertop?.reduce(
              (prev, curr) => prev + Number(curr.quantity),
              0
            ) ?? 0,
          total:
            registrySale?.special?.countertop?.reduce(
              (prev, curr) => prev + Number(curr.cost),
              0
            ) ?? 0,
          price: {
            price: Number(
              registryCost?.special?.countertop?.[0]?.unitPrice ?? 0
            ),
          },
        });
      } else {
        setCountertop(null);
      }

      const backsplashTexture = sceneManager.backsplash?.texture;
      if (backsplashTexture) {
        setBacksplash({
          thumbnail_url: backsplashTexture.url,
          name: backsplashTexture.textureCode,
          width:
            registryCost?.special?.backsplash?.reduce(
              (prev, curr) => prev + Number(curr.quantity),
              0
            ) ?? 0,
          total:
            registrySale?.special?.backsplash?.reduce(
              (prev, curr) => prev + Number(curr.cost),
              0
            ) ?? 0,
          price: {
            price: Number(
              registryCost?.special?.backsplash?.[0]?.unitPrice ?? 0
            ),
          },
        });
      } else {
        setBacksplash(null);
      }
    }
  }, []);

  const renderCardItem = item => {
    const textureFrame = item?.textures?.get('frame');
    const size = [];
    if (item?.moduleData?.width)
      size.push(roundTo(item.moduleData.width * 1000, 0));
    if (item?.moduleData?.depth)
      size.push(roundTo(item.moduleData.depth * 1000, 0));
    if (item?.moduleData?.height)
      size.push(roundTo(item.moduleData.height * 1000, 0));

    return (
      <>
        <CardItem
          icon={item.thumbnail_url}
          title={getValueFromString(item.moduleData?.name)}
          content={[
            <span className="line-clamp-1 truncate text-body-medium text-black-medium">
              {`${size.join(' x ')} mm,`}
            </span>,
            textureFrame ? (
              <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium text-black-medium ellipsis-multiline-1">
                    {textureFrame.paintColor ?? textureFrame.textureCode}
                  </span>
                  <div className="flex w-[24px] h-[14px]">
                    {textureFrame.paintColor ? (
                      <span className={`bg-[${textureFrame.paintColor}]`} />
                    ) : (
                      <img src={textureFrame.textureUrl} alt="texture" />
                    )}
                  </div>
                </div>
              </span>
            ) : (
              <></>
            ),
          ]}
        />
      </>
    );
  };

  const renderSubCardItem = item => {
    const textureFrame = item?.textures?.get('frame');
    const textureDoor = item?.textures?.get('DOOR');
    const textureBedSlat = item?.textures?.get('vat_giuong');
    const textureGlass = item?.textures?.get('GLASS-PANEL');

    const insides = item.listInside
      ?.filter(item =>
        [
          InsideType.HPANEL,
          InsideType.VPANEL,
          InsideType.DRAWER,
          InsideType.U_DRAWER,
          InsideType.VCURVE,
          InsideType.HANDLE,
          InsideType.VPANEL2,
          // InsideType.CLOTHES_HANGER,
          InsideType.HPANEL_RIGHT,
          InsideType.HPANEL_LEFT,
          InsideType.HPANEL_SHOE,
          InsideType.BED_SLAT,
          InsideType.LIFT_SUPPORT,
        ].includes(item.type)
      )
      .reduce((prev, curr) => {
        const index = prev.findIndex(i => i.name === curr.name);
        if (index >= 0) {
          const arr = [...prev];
          arr[index] = {
            ...arr[index],
            quantity: arr[index].quantity + 1,
          };
          return arr;
        }
        return [...prev, { ...curr, quantity: 1 }];
      }, []);
    const doors = item.listInside
      ?.filter(item => [InsideType.DOOR].includes(item.type))
      .reduce((prev, curr) => {
        const index = prev.findIndex(i => i.name === curr.name);
        const beveled = curr.gltf.userData.beveled;
        if (index >= 0) {
          const arr = [...prev];
          arr[index] = {
            ...arr[index],
            quantity: arr[index].quantity + 1,
          };
          return arr;
        }
        return [...prev, { ...curr, beveled, quantity: 1 }];
      }, []);
    const standardLock = item.listInside
      ?.filter(item => [InsideType.LOCK].includes(item.type))
      .reduce((prev, curr, currIndex) => {
        if (currIndex > 0) {
          const arr = [...prev];
          arr[0] = {
            ...arr[0],
            quantity: arr[0].quantity + 1,
          };
          return arr;
        }
        return [...prev, { ...curr, quantity: 1 }];
      }, []);
    const clothesHangers = item.listInside
      ?.filter(item => [InsideType.CLOTHES_HANGER].includes(item.type))
      .reduce((prev, curr) => {
        const box = new THREE.Box3().setFromObject(curr.gltf);
        const size = box.getSize(new THREE.Vector3());
        const length = roundTo(Math.max(size.x, size.y, size.z) * 1000, 0);
        const index = prev.findIndex(i => i.length === length);
        if (index >= 0) {
          const arr = [...prev];
          arr[index] = {
            ...arr[index],
            quantity: arr[index].quantity + 1,
          };
          return arr;
        }
        return [...prev, { ...curr, quantity: 1, length }];
      }, []);
    const leds = item.listInside
      ?.filter(item =>
        [InsideType.LED_RECESSED, InsideType.LED_CORNER].includes(item.type)
      )
      .reduce((prev, curr) => {
        const box = new THREE.Box3().setFromObject(curr.gltf);
        const size = box.getSize(new THREE.Vector3());
        const length = roundTo(Math.max(size.x, size.y, size.z), 3);
        const index = prev.findIndex(
          i => i.length === curr.length && i.name === curr.name
        );
        if (index >= 0) {
          const arr = [...prev];
          arr[index] = {
            ...arr[index],
            quantity: arr[index].quantity + 1,
          };
          return arr;
        }
        return [...prev, { ...curr, quantity: 1, length }];
      }, []);
    const legsKhungSat = item.listInside
      ?.filter(item => [InsideType.KHUNG_SAT].includes(item.type))
      .reduce((prev, curr) => {
        const box = new THREE.Box3().setFromObject(curr.gltf);
        const size = box.getSize(new THREE.Vector3());
        const orientation = GeometryUtils.getModuleOrientation(curr.gltf);
        if (['ROTATED_270', 'ROTATED_90'].includes(orientation)) {
          const length = roundTo(size.x * 1000, 0);
          const index = prev.findIndex(i => i.length === length);
          if (index >= 0) {
            const arr = [...prev];
            arr[index] = {
              ...arr[index],
              quantity: arr[index].quantity + 1,
            };
            return arr;
          }
          return [...prev, { ...curr, quantity: 1, length }];
        } else if (['NORMAL', 'ROTATED_180'].includes(orientation)) {
          const length = roundTo(size.z * 1000, 0);
          const index = prev.findIndex(i => i.length === length);
          if (index >= 0) {
            const arr = [...prev];
            arr[index] = {
              ...arr[index],
              quantity: arr[index].quantity + 1,
            };
            return arr;
          }
          return [...prev, { ...curr, quantity: 1, length }];
        }
      }, []);
    const legsRoi = item.listInside
      ?.filter(item => [InsideType.CHAN_ROI_TV].includes(item.type))
      .reduce((prev, curr) => {
        const index = prev.findIndex(i => i.name === curr.name);
        if (index >= 0) {
          const arr = [...prev];
          arr[index] = {
            ...arr[index],
            quantity: arr[index].quantity + 1,
          };
          return arr;
        }
        return [...prev, { ...curr, quantity: 1 }];
      }, []);
    return (
      <>
        {insides?.map((item, index) => {
          let paintColor;
          let textureUrl;
          let textureCode;
          const content = [];
          const name = item.name ?? convertTypeToName(item.type);
          let price;

          if (item.type === InsideType.BED_SLAT) {
            paintColor = textureBedSlat?.paintColor;
            textureUrl = textureBedSlat?.textureUrl;
            textureCode = textureBedSlat?.textureCode;
          } else if (
            [
              InsideType.HPANEL,
              InsideType.VPANEL,
              InsideType.DRAWER,
              InsideType.U_DRAWER,
              InsideType.VCURVE,
              InsideType.VPANEL2,
              InsideType.HPANEL_RIGHT,
              InsideType.HPANEL_LEFT,
            ].includes(item.type)
          ) {
            paintColor = textureFrame?.paintColor;
            textureUrl = textureFrame?.textureUrl;
            textureCode = textureFrame?.textureCode;
          }

          if (textureUrl && textureCode) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium text-black-medium ellipsis-multiline-1">
                    {textureCode}
                  </span>
                  <div className="flex w-[24px] h-[14px]">
                    <img src={textureUrl} alt="texture" />
                  </div>
                </div>
              </span>
            );
          }
          if (paintColor) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium text-black-medium ellipsis-multiline-1">
                    {paintColor}
                  </span>
                  <div className="flex w-[24px] h-[14px]">
                    <span className={`bg-[${paintColor}]`}></span>
                  </div>
                </div>
              </span>
            );
          }
          if (price) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                {convertForeignCurrency(item.price)}
              </span>
            );
          }
          return (
            <CardItem
              classNames={{ root: 'ps-[40px]' }}
              key={index}
              icon={item.thumbnail_url}
              title={getValueFromString(name)}
              quantity={item.quantity}
              content={content}
            />
          );
        })}
        {doors?.map((item, index) => {
          let paintColor;
          let textureUrl;
          let textureCode;
          const content = [];
          const name = item.name ?? convertTypeToName(item.type);
          const beveled = item.beveled;
          if (item.type === InsideType.DOOR) {
            paintColor = textureDoor?.paintColor;
            textureUrl = textureDoor?.textureUrl;
            textureCode = textureDoor?.textureCode;
          }

          if (textureUrl && textureCode) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium text-black-medium ellipsis-multiline-1">
                    {textureCode}
                  </span>
                  <div className="flex w-[24px] h-[14px]">
                    <img src={textureUrl} alt="texture" />
                  </div>
                  {(() => {
                    if (item.materialType === 'nhom_kinh') {
                      return (
                        <span className="line-clamp-1 truncate text-body-medium text-black-medium ">
                          <div className="flex items-center gap-8 self-stretch">
                            <span className="text-body-medium text-black-medium ellipsis-multiline-1">
                              20*21 mm
                            </span>
                          </div>
                        </span>
                      );
                    }
                  })()}
                </div>
              </span>
            );
          }
          if (paintColor) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium text-black-medium ellipsis-multiline-1">
                    {paintColor}
                  </span>
                  <div className="flex w-[24px] h-[14px]">
                    <span className={`bg-[${paintColor}]`}></span>
                  </div>
                </div>
              </span>
            );
          }
          if (textureGlass) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium">
                <div className="flex items-center gap-8 self-stretch">
                  <span className="text-body-medium text-black-medium ellipsis-multiline-1">
                    {getValueFromString(textureGlass.textureCode)}
                  </span>
                  <div className="flex w-[24px] h-[14px]">
                    <img src={textureGlass.textureUrl} alt="texture" />
                  </div>
                  {(() => {
                    if (item.materialType === 'nhom_kinh') {
                      return (
                        <span className="line-clamp-1 truncate text-body-medium">
                          <div className="flex items-center gap-8 self-stretch">
                            <span className="text-body-medium text-black-medium ellipsis-multiline-1">
                              5 mm
                            </span>
                          </div>
                        </span>
                      );
                    }
                  })()}
                </div>
              </span>
            );
          }
          if (beveled) {
            content.push(
              <span className="line-clamp-1 truncate text-body-small text-[#258FD2]">
                *{t('No handle')}
              </span>
            );
          } else {
            content.push(
              <span className="line-clamp-1 truncate text-body-small text-[#258FD2]">
                *{t('With handle')}
              </span>
            );
          }
          return (
            <CardItem
              classNames={{ root: 'ps-[40px]' }}
              key={index}
              icon={item.thumbnail_url}
              title={getValueFromString(name)}
              quantity={item.quantity}
              content={
                <div className="flex flex-col items-start">{content}</div>
              }
            />
          );
        })}
        {standardLock?.map((item, index) => {
          return (
            <CardItem
              classNames={{ root: 'ps-[40px]' }}
              key={index}
              icon={item.thumbnail_url}
              title={getValueFromString(item.name)}
              quantity={item.quantity}
              content={<></>}
            />
          );
        })}
        {clothesHangers?.map((item, index) => {
          const name = `${item.name ?? convertTypeToName(item.type)} - ${item.length}mm`;
          return (
            <CardItem
              classNames={{ root: 'ps-[40px]' }}
              key={index}
              icon={item.thumbnail_url}
              title={getValueFromString(name)}
              quantity={item.quantity}
              content={
                <div className="flex flex-col items-start gap-[6px]">
                  <span className="text-body-medium text-black-medium">
                    {item.length} mm
                  </span>
                </div>
              }
            />
          );
        })}
        {leds?.map((item, index) => {
          const content = [];
          const name = `${item.name ?? 'LED'}`;
          const price = sceneManager?.nestingController?.ledPrice || 0;
          // if (price) {
          //   content.push(
          //     <span className="line-clamp-1 truncate text-body-medium !font-semibold text-black-high">
          //       {((price ?? 0) * item.length).toLocaleString('vi-VN', {
          //         style: 'currency',
          //         currency: 'VND',
          //       })}
          //     </span>
          //   );
          // }
          return (
            <CardItem
              classNames={{ root: 'ps-[40px]' }}
              key={index}
              icon={item.thumbnail_url}
              title={getValueFromString(name)}
              quantity={item.quantity}
              content={
                <div className="flex flex-col items-start gap-[6px]">
                  <span className="text-body-medium text-black-medium">
                    {item.length * 1000} mm
                  </span>
                </div>
              }
            />
          );
        })}
        {legsRoi?.map((item, index) => {
          const content = [];
          const name = item.name ?? convertTypeToName(item.type);
          const price = item.price ?? 0;
          if (price) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                {convertForeignCurrency(price)}
              </span>
            );
          }
          return (
            <CardItem
              classNames={{ root: 'ps-[40px]' }}
              key={index}
              icon={item.thumbnail_url}
              title={getValueFromString(name)}
              quantity={item.quantity}
              content={
                <div className="flex flex-col items-start">{content}</div>
              }
            />
          );
        })}
        {legsKhungSat?.map((item, index) => {
          const content = [];
          const name = `${item.name ?? convertTypeToName(item.type)} - ${item.length}mm`;
          const price = item.price || 0;
          if (price) {
            content.push(
              <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                {convertForeignCurrency(((price ?? 0) * item.length) / 1000)}
              </span>
            );
          }
          return (
            <CardItem
              classNames={{ root: 'ps-[40px]' }}
              key={index}
              icon={item.thumbnail_url}
              title={getValueFromString(name)}
              quantity={item.quantity}
              content={
                <div className="flex flex-col items-start">{content}</div>
              }
            />
          );
        })}
      </>
    );
  };

  const renderWoodDetail = () => {
    return (
      <div className="flex flex-col gap-[16px] items-center justify-start self-stretch">
        {woodProducts.length ? (
          <div className="flex flex-col items-start gap-16 self-stretch">
            <div className="flex py-[8px] px-[16px] gap-[8px] justify-start flex-col items-center self-stretch rounded-[8px] bg-primary-primaryFill">
              <div className="flex justify-between items-center self-stretch">
                <div className="flex flex-col items-start gap-2">
                  <span className="text-title-small">{t('Wood product')}</span>
                  <span className="text-body-small text-black/60">
                    {`${woodProducts.length} ${t('Product')}`}
                  </span>
                </div>
                <div className="flex gap-[4px]">
                  <span className="text-body-large-emphasized text-black-high">
                    {convertForeignCurrency(
                      (() => {
                        if (
                          !sceneManager?.skipSpecialTexture &&
                          specialTexture
                        ) {
                          return roundTo(
                            totalPrice?.costFrame +
                              totalPrice?.costCurveBlocks -
                              (totalPrice?.totalMaterials?.costBoards ?? 0) *
                                0.05,
                            0
                          );
                        } else {
                          return roundTo(
                            totalPrice?.costFrame + totalPrice?.costCurveBlocks,
                            0
                          );
                        }
                      })()
                    )}
                  </span>
                </div>
              </div>
              {/* {(() => {
                  if (specialTexture && !sceneManager?.skipSpecialTexture) {
                    return (
                      <>
                        <div className="flex justify-between items-center self-stretch">
                          <div className="flex items-center gap-[6px] grow">
                            <span className="text-body-medium font-semibold text-black-high">
                              {t('Discount')}
                            </span>
                            <Tooltip
                              title={
                                <span className="text-body-medium text-black-medium">
                                  {t('Giá ván')}
                                </span>
                              }
                            >
                              <span className="w-[12px] h-[12px] flex text-Accents-Blue">
                                <Icon.ICInfoFill />
                              </span>
                            </Tooltip>
                          </div>
                          <span className="text-body-large text-Accents-Red font-semibold">
                            {roundTo(
                              (totalPrice?.totalMaterials?.costBoards ?? 0) *
                                0.05 *
                                -1,
                              0
                            ).toLocaleString('vi-VN', {
                              style: 'currency',
                              currency: 'VND',
                            })}
                          </span>
                        </div>
                        <Divider className="m-0 !p-0" type="horizontal" />
                        <div className="flex justify-between items-center self-stretch">
                          <span className="text-title-small">{t('Total')}</span>
                          <span className="text-body-large text-Accents-Red font-semibold">
                            {roundTo(
                              totalPrice?.totalFrames +
                                totalPrice?.totalOthers?.costCurveBlocks?.total -
                                (totalPrice?.totalMaterials?.costBoards ?? 0) *
                                  0.05,
                              0
                            ).toLocaleString('vi-VN', {
                              style: 'currency',
                              currency: 'VND',
                            })}
                          </span>
                        </div>
                      </>
                    );
                  }
                })()} */}
            </div>

            {Object.entries(mapModule).map(([, values], index) => {
              return (
                <div
                  key={index}
                  className="flex flex-col items-start gap-8 self-stretch"
                >
                  <span className="text-title-small">
                    {t(capitalize(convertCodeToName(values[0])))}
                  </span>
                  <div className="flex flex-col items-start self-stretch p-[8px] gap-[8px] rounded-[8px] border-[1px] border-[#E0E0E0] border-solid bg-white">
                    {values[1].map((item, i) => {
                      return (
                        <div
                          key={i}
                          className="flex flex-col p-[8px] items-start gap-[8px] self-stretch"
                        >
                          {renderCardItem(item)}
                          {renderSubCardItem(item)}
                          {values[1].length - 1 !== i ? (
                            <Divider className="m-0 !p-0" type="horizontal" />
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
            {lightSwitches || ledDrivers || ledsDecor ? (
              <div className="flex flex-col items-start gap-8 self-stretch">
                <span className="text-title-small">LED</span>
                <div className="flex p-16 flex-col items-start self-stretch rounded-[8px] bg-white">
                  {ledsDecor > 0 && (
                    <CardItem
                      icon={'/assets/images/led.png'}
                      title={'LED decor'}
                      content={[
                        <>
                          <div className="flex flex-col items-start gap-[4px] self-stretch">
                            <span className="text-body-medium text-black-medium ">
                              {ledsDecor * 1000} mm
                            </span>
                          </div>
                        </>,
                      ]}
                      quantity={undefined}
                    />
                  )}
                  {lightSwitches && (
                    <CardItem
                      icon={'/assets/images/switch.jpg'}
                      title={t('Switch')}
                      content={[]}
                      quantity={lightSwitches}
                    />
                  )}
                  {ledDrivers && (
                    <CardItem
                      icon={'/assets/images/driver.jpg'}
                      title={t('Driver')}
                      content={[]}
                      quantity={ledDrivers}
                    />
                  )}
                </div>
              </div>
            ) : (
              <></>
            )}
            {count['hinge'] || count['connector'] || count['rail'] ? (
              <div className="flex flex-col items-start gap-8 self-stretch">
                <span className="text-title-small">Linh kiện</span>
                <div className="flex p-16 flex-col items-start self-stretch rounded-[8px] bg-white">
                  {count['hinge'] ? (
                    <CardItem
                      icon={'/assets/images/banle.png'}
                      title={t('Hinge')}
                      content={
                        [
                          // <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                          //   {convertForeignCurrency(
                          //     sceneManager?.nestingController?.hingePrice?.price
                          //   )}
                          // </span>,
                        ]
                      }
                      quantity={count['hinge']}
                    />
                  ) : (
                    <></>
                  )}
                  {count['connector'] ? (
                    <CardItem
                      icon={'/assets/images/chotcam.png'}
                      title={t('Connector')}
                      content={
                        [
                          // <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                          //   {convertForeignCurrency(
                          //     sceneManager?.nestingController?.connectorPrice
                          //       ?.price
                          //   )}
                          // </span>,
                        ]
                      }
                      quantity={count['connector']}
                    />
                  ) : (
                    <></>
                  )}
                  {count['rail'] ? (
                    <CardItem
                      icon={'/assets/images/ray.png'}
                      title={t('Rails')}
                      content={
                        [
                          // <span className="line-clamp-1 truncate text-body-medium-emphasized text-black-medium">
                          //   {convertForeignCurrency(
                          //     sceneManager?.nestingController?.railPrice?.price
                          //   )}
                          // </span>,
                        ]
                      }
                      quantity={count['rail']}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : null}
          </div>
        ) : null}
        {countertop ? (
          <div className="flex flex-col items-start gap-16 self-stretch">
            <div className="flex py-[8px] px-[16px] justify-between items-center self-stretch rounded-[8px] bg-primary-primaryFill">
              <div className="flex justify-between grow items-center gap-[2px]">
                <div className="flex flex-col items-start gap-2">
                  <span className="text-title-small">{t('Countertop')}</span>
                </div>
                <div className="flex gap-[4px]">
                  <span className="text-body-large emphasized text-black/80">
                    {convertForeignCurrency(countertop?.total)}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-col items-start gap-8 self-stretch">
              <div className="flex p-16 flex-col items-start self-stretch rounded-[8px] bg-white">
                {countertop ? (
                  <CardItem
                    icon={countertop.thumbnail_url}
                    title={countertop.name}
                    content={[
                      <span className="line-clamp-1 truncate text-body-medium text-black-medium min-w-full">
                        {roundTo(countertop.width * 1000, 0)} mm
                      </span>,
                      <span className="line-clamp-1 truncate text-body-medium-emphasized text-black-medium">
                        {convertForeignCurrency(countertop.price?.price)}
                      </span>,
                    ]}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        ) : null}
        {backsplash ? (
          <div className="flex flex-col items-start gap-16 self-stretch">
            <div className="flex py-[8px] px-[16px] justify-between items-center self-stretch rounded-[8px] bg-primary-primaryFill">
              <div className="flex justify-between grow items-center gap-[2px]">
                <div className="flex flex-col items-start gap-2">
                  <span className="text-title-small">{t('Backsplash')}</span>
                </div>
                <div className="flex gap-[4px]">
                  <span className="text-body-large emphasized text-black/80">
                    {convertForeignCurrency(backsplash?.total)}
                  </span>
                </div>
              </div>
            </div>
            {backsplash ? (
              <div className="flex flex-col items-start gap-8 self-stretch">
                <div className="flex p-16 flex-col items-start self-stretch rounded-[8px] bg-white">
                  {backsplash ? (
                    <CardItem
                      icon={backsplash.thumbnail_url}
                      title={backsplash.name}
                      content={[
                        <span className="line-clamp-1 truncate text-body-medium text-black-medium min-w-full">
                          {roundTo(backsplash.width * 1000, 0)} mm
                        </span>,
                        <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                          {convertForeignCurrency(backsplash.price?.price)}
                        </span>,
                      ]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : null}
      </div>
    );
  };

  const renderEquipmentsDetail = () => {
    return (
      <div className="flex flex-col gap-[16px] items-center justify-start self-stretch">
        {accessories?.length ? (
          <div className="flex flex-col items-start gap-16 self-stretch">
            <div className="flex py-[8px] px-[16px] justify-between items-center self-stretch rounded-[8px] bg-primary-primaryFill">
              <div className="flex flex-col items-start gap-2">
                <span className="text-title-small">
                  {t('Accessories and Equipments')}
                </span>
                <span className="text-body-small text-black/60">
                  {`${accessories.length} ${t('Product')}`}
                </span>
              </div>
              <div className="flex gap-[4px]">
                <span className="text-body-large-emphasized text-black/80">
                  {convertForeignCurrency(totalPrice?.costEquipments)}
                </span>
              </div>
            </div>
            {accessories?.length ? (
              <div className="flex flex-col items-start gap-8 self-stretch">
                <div className="flex p-16 flex-col items-start self-stretch rounded-[8px] bg-white">
                  {accessories?.map((item, index) => {
                    const content = [];
                    if (item.material) {
                      content.push(
                        <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                          {item.material}
                        </span>
                      );
                    }
                    if (item.price) {
                      content.push(
                        <span className="line-clamp-1 truncate text-body-medium text-black-medium">
                          {convertForeignCurrency(item.price)}
                        </span>
                      );
                    }
                    return (
                      <CardItem
                        key={index}
                        icon={item.thumbnail_url}
                        title={item.name ?? t('Accessories')}
                        content={content}
                        quantity={item.count}
                      />
                    );
                  })}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : null}
      </div>
    );
  };

  if (mapModule.length)
    return (
      <>
        <div className="flex flex-col items-start grow self-stretch overflow-auto max-h-[570px]">
          <TabComponent
            items={[
              {
                key: 'wood',
                label: (
                  <div className="flex items-center justify-start gap-[8px]">
                    <span className="w-[20px] h-[20px] flex items-center justify-center">
                      <Icon.ICStack />
                    </span>
                    <span className="text-body-large font-semibold">
                      {t('Wood product')}
                    </span>
                  </div>
                ),
              },
              {
                key: 'accessoriesAndEquipments',
                label: (
                  <div className="flex items-center justify-start gap-[8px]">
                    <span className="w-[20px] h-[20px] flex items-center justify-center">
                      <Icon.ICCountertops />
                    </span>
                    <span className="text-body-large font-semibold">
                      {t('Accessories and Equipments')}
                    </span>
                  </div>
                ),
                disabled: !accessories?.length,
              },
            ]}
            style={{ width: '100%' }}
            className={
              'px-[24px] py-[12px] [&_.ant-tabs-content-holder]:hidden'
            }
            defaultActiveKey={tab}
            onChange={value => setTab(value)}
          />
          <div className="flex flex-col gap-[16px] p-[24px] self-stretch grow bg-backgrounds-timeline">
            {tab === 'wood' && renderWoodDetail()}
            {tab === 'accessoriesAndEquipments' && renderEquipmentsDetail()}
          </div>
        </div>
        <div
          className="flex p-16 justify-end items-center gap-16 self-stretch"
          style={{ borderTop: '1px solid #CFD1D2' }}
        >
          <ButtonPrimaryMedium
            title={t('Next')}
            // preIcon={<Icon.ICArrowForward />}
            onClick={() => {
              // navigate(ROUTER.CART);
              setOpen(false);
              setShowCabinetTrimView(true);
              handleSaveAllDesign({ complete: true, containerId });
            }}
          />
        </div>
      </>
    );
};
